/*
 * Collection 101 — reusable section script.
 * Namespaced under window.COL101. Handles only the scroll-fade reveal
 * (the hover zoom is pure CSS). Safe to include multiple times on a
 * page since each <script> execution is guarded.
 */
(function () {
  if (window.COL101 && window.COL101.__initialized) return;
  window.COL101 = window.COL101 || {};
  window.COL101.__initialized = true;

  function boot() {
    var items = document.querySelectorAll('[data-col101-reveal]');
    if (!items.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
